import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-hvmi-wizard-complete',
  templateUrl: './connect-hvmi-wizard-complete.component.html',
  styleUrls: ['./connect-hvmi-wizard-complete.component.scss'],
})
export class ConnectHvmiWizardCompleteComponent implements OnInit {
  @Output() done = new EventEmitter()

  ngOnInit(): void {}
}
